<template>
  <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
    :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="false" :fields="fields" :searchDisable="true"
    @change="change" @changeFunction="changeFunction" v-model="val" />
</template>
<script>
export default {
  name: "products",
  props: ['id'],
  created() {
    this.itemLink = `business/groups/${this.id}/customers`;
    this.setLink = `business/groups/${this.id}/customers`;
  },
  methods: {
    changeFunction(val) { },
    change(val) { },

  },
  data() {
    return {
      val: [],
      modalCreate: "course_group",
      fields: [
        {
          col: 'col-12 col-md-6',
          label: "Выберите учителя",
          key: "customer",
          type: "select",
          selectKey: "full_name",
          modal: "customer",
          prefix: "group_customer",
        },
        {
          key: "label",
          label: "Статус учителя",
          type: "field",
          textType: "text",
          col: 'col-12 col-md-6',
        },
        {
          col: 'col-12 col-md-12',
          label: "Предметы учителя",
          key: "disciplines",
          type: "selects",
          selectKey: "title",
          modal: "business_discipline",
          prefix: "discipline_d_t",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_group_customer",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "full_name",
          title: "ФИО",
          checkbox: false,
          disableLink: true,
          object: 'position',
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "label",
          title: "Статус",
          checkbox: false,
        },
        {
          key: "join_at",
          title: "Зачислен",
          checkbox: false,
          disableLink: true,
          dateTimeFormat: true,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
